import React from 'react'
import { StreamData } from 'types/streamData'
import LinkedAvatar from './LinkedAvatar'

type StyledAvatarProps = {
  streamData: StreamData
  diameter?: string
  fallbackFontSize?: string
}

const StyledAvatar = ({ streamData, diameter, fallbackFontSize }: StyledAvatarProps) => {
  const {
    isRetweet,
    originalAuthorAvatarUrl,
    originalAuthorName,
    originalAuthorUrl,
    originalAuthor
  } = streamData
  let { avatarUrl, authorName, authorUrl, author } = streamData

  if (isRetweet!) {
    avatarUrl = originalAuthorAvatarUrl
    authorName = originalAuthorName
    authorUrl = originalAuthorUrl || authorUrl
    author = originalAuthor
  }

  const name = authorName || author

  return (
    <LinkedAvatar
      fallbackFontSize={fallbackFontSize}
      diameter={diameter}
      name={name}
      avatarUrl={avatarUrl}
      url={authorUrl}
    />
  )
}

export default StyledAvatar
